// File: src/hooks/usePermissions.js

import { usePermission } from '../contexts/PermissionContext';
import { RESOURCES, ACTIONS } from '../constants/permissions';

/**
 * Hook to access permission context
 * @returns {Object} Permission context with all permission methods
 */
export const usePermissions = () => {
  return usePermission();
};

/**
 * Hook to check if user has a specific permission
 * @param {string} resource - Resource name (e.g., 'users', 'assessments')
 * @param {string} action - Action name (e.g., 'create', 'read', 'update', 'delete')
 * @returns {boolean} True if user has permission
 */
export const useHasPermission = (resource, action) => {
  const { hasPermission } = usePermissions();
  return hasPermission(resource, action);
};

/**
 * Hook to check if user can access a specific organization
 * @param {string} organizationId - Organization ID
 * @returns {boolean} True if user can access the organization
 */
export const useCanAccess = (organizationId) => {
  const { canAccess } = usePermissions();
  return canAccess(organizationId);
};

// Export constants for convenience
export { RESOURCES, ACTIONS };

export default usePermissions;

